import type { Component, Entity2D } from '../../odie';
import { TunaFishBlockProps } from '../defs/block';
import { TunaFishBlockView } from '../views/blocks/TunaFishBlockView';

export type TunaFishBlockComponentOptions = {
  props: TunaFishBlockProps;
};

export class TunaFishBlockComponent implements Component {
  public static readonly NAME = 'blockTunaFish';
  public entity!: Entity2D;
  public view!: TunaFishBlockView;

  public init(options: TunaFishBlockComponentOptions): void {
    this.view = new TunaFishBlockView(options.props);
  }
}
